export default "__VITE_ASSET__QG7pTyav__"